import { Button, Heading } from '@tmov/design-system';
import { WaveVariantB } from '@tmov/design-system/icons';
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { LoadingContainer } from '../../../components/LoadingContainer';
import apiShipper from '../../../services/apiShipper';
import CotacaoDetalhes from './CotacaoDetalhes';
import CotacaoTimer from './CotacaoTimer';
import DrawerHistorico from './DrawerHistorico';
import useFetchCotacao from './hooks/useCotacaoData';
import usePropostaData from './hooks/usePropostaData';
import PropostaTable from './PropostaTable';
import {
  CardContent,
  Container,
  ContainerBody,
  Header,
  HeaderLeft,
} from './styles';

function Dashboards() {
  const { id: idCotacao } = useParams();
  const { cotacao, loading, fetchCotacao } = useFetchCotacao(idCotacao);
  const [visible, setVisible] = useState();
  const [propostas, setPropostas] = useState([]);
  const {
    propostaData,
    setPropostaData,
    loadingPropostaData,
    fetchProposta,
  } = usePropostaData({
    idCotacao,
  });
  const bestLance = useMemo(() => {
    if (propostaData && propostaData.length) {
      return propostaData.reduce(
        (bestValor, { valor_lance }) =>
          valor_lance < bestValor ? valor_lance : bestValor,
        Number.MAX_VALUE
      );
    }
    return null;
  }, [propostaData]);

  const handleHistorico = async () => {
    const { data } = await apiShipper.get(`/cotacoes/${idCotacao}/propostas`);
    setPropostas(data);
    setVisible(true);
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <Heading variant="h2">Cotações</Heading>
        </HeaderLeft>
        <Button onClick={handleHistorico}>Ver historico</Button>
      </Header>
      <DrawerHistorico
        propostas={propostas}
        visible={visible}
        handleClose={() => setVisible(false)}
      />
      {loading && (
        <LoadingContainer>
          <WaveVariantB size="60px" />
        </LoadingContainer>
      )}
      <ContainerBody loading={loading ? 'true' : undefined}>
        <CardContent>
          <CotacaoTimer
            status={cotacao?.status}
            periodoFim={cotacao?.periodo_fim}
            bestLance={bestLance}
            fetchCotacao={fetchCotacao}
          />
          <CotacaoDetalhes cotacao={cotacao} />
        </CardContent>
        <PropostaTable
          idCotacao={idCotacao}
          cotacaoStatus={cotacao?.status}
          cotacaoValorFinal={cotacao?.valor_final}
          fetchProposta={fetchProposta}
          propostaData={propostaData}
          setPropostaData={setPropostaData}
          loadingPropostaData={loadingPropostaData}
        />
      </ContainerBody>
    </Container>
  );
}

export default Dashboards;
